import { NavigateFunction } from 'react-router-dom';

import { IDeepLink } from '@gem/models/deeplinksModel';

import Tasks from 'APP/Tasks';
import { mapDeepLinkType } from 'APP/main/Modules/DeepLinkHandler/DeepLinkHandler.utils';

export function openDesktopDeeplinkHandler(url: string, navigateFunc: NavigateFunction): void {
  const [_, queryPart = ''] = url.split('?');
  const deepLinkQueryParams = Object.fromEntries(new URLSearchParams(queryPart));

  if (!queryPart.length && !deepLinkQueryParams.deepLink) {
    return;
  }

  const deepLinkParams: IDeepLink = {
    ...deepLinkQueryParams,
    type: mapDeepLinkType(deepLinkQueryParams.type),
    expired: !!deepLinkQueryParams.expired,
    entityId: deepLinkQueryParams.entityId ?? '',
  };

  Tasks.deeplinks.handleDeepLink({ deepLinkParams, navigateTo: navigateFunc });
}
